export default "__VITE_ASSET__IxSNAfo3__"